import { render, staticRenderFns } from "./UusiSalasana.vue?vue&type=template&id=4c2e42d8&scoped=true&"
import script from "./UusiSalasana.vue?vue&type=script&lang=js&"
export * from "./UusiSalasana.vue?vue&type=script&lang=js&"
import style0 from "./UusiSalasana.vue?vue&type=style&index=0&id=4c2e42d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2e42d8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c2e42d8')) {
      api.createRecord('4c2e42d8', component.options)
    } else {
      api.reload('4c2e42d8', component.options)
    }
    module.hot.accept("./UusiSalasana.vue?vue&type=template&id=4c2e42d8&scoped=true&", function () {
      api.rerender('4c2e42d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UusiSalasana.vue"
export default component.exports